module.exports = {"431021001":"龙潭街道","431021002":"鹿峰街道","431021003":"黄沙坪街道","431021102":"仁义镇","431021103":"太和镇","431021104":"洋市镇","431021105":"和平镇","431021106":"流峰镇","431021107":"塘市镇","431021108":"莲塘镇","431021109":"舂陵江镇","431021110":"荷叶镇","431021111":"方元镇","431021112":"樟市镇","431021113":"敖泉镇","431021114":"正和镇","431021115":"浩塘镇","431021116":"雷坪镇","431021117":"欧阳海镇","431021118":"四里镇","431021209":"桥市乡","431021226":"白水瑶族乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/431021.json
// module id = 1729
// module chunks = 0